import _sortBy from "lodash/sortBy";
export var fetchAllIntegrations = function fetchAllIntegrations(client) {
  return client.get("/content/entries/integrations").then(function (value) {
    // If the integration is in Private Beta, we want to filter it out of the response.
    var filteredValue = value.filter(function (value) {
      return !value.privateBeta;
    });
    return _sortBy(filteredValue, function (item) {
      return item.name;
    });
  });
};
export var fetchIntegration = function fetchIntegration(client, slug) {
  return client.get("/content/entries/integrations?url=".concat(slug)).then(function (value) {
    // If the integration is in Private Beta, we do not want to generate a static page for the integration.
    if (value.privateBeta) {
      return;
    }

    return value;
  });
};